
import { primary1_30, primary2 } from '@shane-collective/design-system';
import { YStack, Text } from 'tamagui'; 
import MaintenanceIllustration from '../../images/illustrations/down-for-maintenance.png'

function MaintenancePage() {

  return (
    <YStack
      height="100%"
      justifyContent="center"
      alignItems="center"
      backgroundColor={primary1_30}
      padding="$4"
    >
      <YStack
        justifyContent="center"
        alignItems="center"
        maxWidth={500}
        backgroundColor={primary1_30}
        borderRadius="$6"
        padding="$6"
      >
        <YStack>
            <img src={MaintenanceIllustration} height="400px" alt="Down for maintenance"/>
        </YStack>
        <Text
          fontSize={32}
          fontWeight="bold"
          color={primary2}
          marginBottom="$4"
          fontFamily= "$rethinkSans"
        >
          We'll Be Back Soon!
        </Text>
        <Text
          fontSize={18}
          color={primary2}
          marginBottom="$6"
          textAlign="center"
          fontFamily= "$rethinkSans"

        >
          This service is temporarily down for maintenance
        </Text>
       
      </YStack>
    </YStack>
  );
}

export default MaintenancePage;
